module.exports = __webpack_public_path__ + "components/patterns/paragraphWhatsOnTabListing/paragraph-whats-on-tab-listing.tpl.php";